import React, { useEffect, useRef, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { observer } from 'mobx-react'
import toastr from 'toastr'

import { SignatureCanvas, SignaturePad } from 'mobileApp/common/component/signature'
import { mdiStore, deviceStore } from 'mobileApp/store'
import { MdiLayout } from '../layout'

export const S04TmSignature: React.FC<RouteComponentProps> = observer((props) => {
  const canvasRef = useRef<SignatureCanvas>(null)
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    mdiStore.tmSignature && canvasRef.current && canvasRef.current.fromDataURL(mdiStore.tmSignature)
  }, [])

  const handleClear = () => canvasRef.current!.clear()
  const handleNext = () => {
    setDisabled(true)
    if (deviceStore.isPhone) mdiStore.navi.goNext()
    else
      mdiStore.uploadTmSignature(canvasRef.current!.toDataURL()).then((statusCode) => {
        if (statusCode === 200) mdiStore.navi.goNext()
        else {
          const errMsg = statusCode === 400 ? '簽名不可空白！' : `上傳簽名檔失敗！ 錯誤碼：${statusCode}`
          toastr.error(errMsg)
          setDisabled(false)
        }
      })
  }

  return (
    <MdiLayout title="本人已審閱貴公司所提供之保單條款" step={3}>

      <section className="my-3 d-flex justify-content-between">
          <div>
            <button type="button" className="btn btn-light" onClick={mdiStore.navi.goBack}>
              上一步
            </button>
            {deviceStore.isPhone ? null : (
              <button type="button" className="btn btn-light ml-3" onClick={handleClear}>
                清除
              </button>
            )}
            </div>
          <button type="button" className="btn btn-secondary" disabled={disabled} onClick={handleNext}>
            下一步
          </button>
      </section>

      {deviceStore.isPhone ? null : <SignaturePad title="要保人簽名" canvasRef={canvasRef} height="240px" />}
    </MdiLayout>
  )
})
